import {
	BillingTypeTargetForOption,
	BillingTypeTerm,
	CurrencyType,
	OptionType,
	SaleTypeForPlan,
	SaleTypeForTerm,
} from "@/lib/gql/__generated__/graphql";

import { convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour } from "@/components/features/_shared/validation-schema/converter";
import { DAY_OF_THE_WEEK_LIST } from "@/components/features/items/edit/_shared/constants/day-of-the-week";

import type { ProductOptionFormModel } from "../type";

type Props = {
	hotelID: string;
	optionID: string;
	queryData: ProductOptionFormModel["QueryData"];
};

export const DEFAULT_PRODUCT_OPTION_INPUT_MODEL = ({ hotelID, optionID, queryData }: Props) => {
	const { hotelPolicy } = queryData;

	// 初期値が他画面での設定値に依存する
	const requiredPrepMillisecond = hotelPolicy.requiredPrepMillisecond;
	const { requiredPrepMillisecondBeforeDate, requiredPrepMillisecondBeforeHour } =
		convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour(requiredPrepMillisecond);
	const cancelPolicy = hotelPolicy.cancelPolicy;

	const inputModel: ProductOptionFormModel["InputModel"] = {
		hotelID,
		optionID,

		name: "",
		description: "",

		mainKeyVisual: { bucket: "", key: "", region: "", mimeType: null, fileName: null },
		keyVisuals: [],

		optionType: OptionType.Service,

		price: {
			amount: 0,
			currencyType: CurrencyType.Jpy,
		},

		availablePlanIDs: [],

		billingTypeTarget: BillingTypeTargetForOption.Person,
		billingTypeTerm: BillingTypeTerm.PerDate,

		inSale: false,
		isNextMorning: false,
		isNotDiscountTarget: false,

		maxBuyableNumPerTarget: 0,
		maxDailyStockNum: undefined,
		maxStockNum: undefined,
		minimumBuyableNumPerTarget: undefined,
		multiSubOptionSelectable: false,

		saleEnd: undefined,
		saleStart: undefined,
		saleStartBeforeDate: undefined,
		saleTypeForPlan: SaleTypeForPlan.Ordinary,

		saleTypeForTerm: SaleTypeForTerm.Always,

		stayableDayOfTheWeek: DAY_OF_THE_WEEK_LIST.map((item) => item.value),
		isHolidayStayable: undefined,
		stayableStart: undefined,
		stayableEnd: undefined,

		subOptions: [],
		useAsSubOption: false,
		isDateTabbedTimeSelectionEnabled: false,

		// 初期値が他画面での設定値に依存する
		requiredPrepMillisecond,
		requiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeHour,
		cancelPolicy,
	} satisfies ProductOptionFormModel["InputModel"];

	return inputModel;
};
